/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ManufacturerModel } from './ManufacturerModel';
import {
    ManufacturerModelFromJSON,
    ManufacturerModelFromJSONTyped,
    ManufacturerModelToJSON,
} from './ManufacturerModel';
import type { Page } from './Page';
import {
    PageFromJSON,
    PageFromJSONTyped,
    PageToJSON,
} from './Page';

/**
 * 
 * @export
 * @interface PageableManufacturerModels
 */
export interface PageableManufacturerModels {
    /**
     * 
     * @type {Array<ManufacturerModel>}
     * @memberof PageableManufacturerModels
     */
    result: Array<ManufacturerModel>;
    /**
     * 
     * @type {Page}
     * @memberof PageableManufacturerModels
     */
    page: Page;
}

/**
 * Check if a given object implements the PageableManufacturerModels interface.
 */
export function instanceOfPageableManufacturerModels(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    isInstance = isInstance && "page" in value;

    return isInstance;
}

export function PageableManufacturerModelsFromJSON(json: any): PageableManufacturerModels {
    return PageableManufacturerModelsFromJSONTyped(json, false);
}

export function PageableManufacturerModelsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageableManufacturerModels {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': ((json['result'] as Array<any>).map(ManufacturerModelFromJSON)),
        'page': PageFromJSON(json['page']),
    };
}

export function PageableManufacturerModelsToJSON(value?: PageableManufacturerModels | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': ((value.result as Array<any>).map(ManufacturerModelToJSON)),
        'page': PageToJSON(value.page),
    };
}

